import _ from 'lodash';

export default function getCollectedPetTypes(pets) {
	return _.chain(pets)
		.filter('isCollected')
		.map(pet => pet.petType)
		.value();
}



// WEBPACK FOOTER //
// ./src/selectors/getCollectedPetTypes.js